import React from 'react'
import { sortable } from 'react-sortable'

class Item extends React.Component {
  render() {
    return (
      <tr style={{ backgroundColor: '#fff' }} {...this.props}>
        <td>{this.props.item.id}</td>
        <td>{this.props.item.is_senior ? 'Yes' : 'No'}</td>
        <td>{this.props.item.is_elementary ? 'Yes' : 'No'}</td>
        <td>{this.props.item.is_holiday ? 'Yes' : 'No'}</td>
        <td>{this.props.item.name}</td>
        <td>{this.props.item.price_with}</td>
        <td>{this.props.item.price_without}</td>
        <td>{this.props.item.image_count}</td>
        <td>{this.props.item.css_name}</td>
        <td>
          <a href={`/admin/addons/${this.props.item.id}`}>Show</a> |
          <a href={`/admin/addons/${this.props.item.id}/edit`}>Edit</a>
          <a href={`/admin/addons/${this.props.item.id}`} data-method="delete">Delete</a>
        </td>
      </tr>
    )
  }
}

// Non-draggable row for the column-sorted view (SortableAddons renders these
// while a sort is active so dragging can't fight the sort or leak into the
// persisted position order).
export const StaticItem = Item;

export default sortable(Item)
